import ArticleDetails from '../../../sections/ArticleDetails';
import SiteLayout from '../../../layouts/SiteLayout/SiteLayout';
import { useRootSelector } from '../../../../store/hooks';
import {
  selectSiteArticleDetailsData,
  selectSiteArticleDetailsMeta,
} from '../../../../store/features/siteArticles/siteArticleDetails';
import { useCreateArticleCanonicalUrl } from '../../../../hooks/useCreateArticleCanonicalUrl';
import styles from './ArticleDetailsView.module.scss';
import { siteTypesEnum } from '../../../../helpers';
import { selectPageConfig } from '../../../../store/features/pageConfig';

const { BRAND_HUB } = siteTypesEnum();

const TypedSiteLayout = SiteLayout as any;

export default function ArticleDetailsView() {
  const articleData = useRootSelector(selectSiteArticleDetailsData);
  const articleMeta = useRootSelector(selectSiteArticleDetailsMeta);
  const pageConfig = useRootSelector(selectPageConfig);
  const {
    summary,
    articlePath,
    pathOfPrimarySite,
    typeOfPrimarySite,
    tenantOfPrimarySite,
  } = articleData || {};

  const canonicalUrl = useCreateArticleCanonicalUrl(
    pathOfPrimarySite,
    typeOfPrimarySite,
    tenantOfPrimarySite,
    articlePath,
  );

  const buildNoIndex = () => {
    if (typeOfPrimarySite === BRAND_HUB) return true;
    if (pageConfig.tenantId !== tenantOfPrimarySite) return true;
    if (pathOfPrimarySite && pathOfPrimarySite !== pageConfig.sitePath)
      return true;
    return false;
  };

  const helmet = {
    title: articleMeta.title,
    description: summary,
    canonical: canonicalUrl,
    noindex: buildNoIndex(),
  };

  return (
    <TypedSiteLayout helmet={helmet}>
      <div className={styles.wrapper}>
        <ArticleDetails />
      </div>
    </TypedSiteLayout>
  );
}
